import { Link } from "react-router-dom";
import { ArrowLeft, Trophy, ShieldAlert, RefreshCw } from "lucide-react";
import { StandingsWidget } from "../components/StandingsWidget";
import { AdSlot } from "../components/ads/AdSlot";
import { SectionHeading } from "../components/SectionHeading";

export default function Standings() {
  return (
    <div data-testid="standings-page">
      {/* Hero */}
      <section className="relative overflow-hidden border-b border-brand-navy">
        <div className="bg-grid pointer-events-none absolute inset-0 opacity-30" />
        <div className="relative z-10 mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
          <Link
            to="/sports/football"
            data-testid="standings-back-link"
            className="inline-flex items-center gap-2 text-sm text-brand-silver transition-colors duration-300 hover:text-white"
          >
            <ArrowLeft className="h-4 w-4" /> Football Hub
          </Link>

          <div className="mt-8 flex items-center gap-4">
            <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-brand-royal/40 bg-brand-navy/50 text-brand-cyan glow-cyan">
              <Trophy className="h-7 w-7" />
            </div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-brand-cyan/15 px-3 py-1 font-mono-data text-[10px] font-semibold uppercase tracking-wider text-brand-cyan">
              <RefreshCw className="h-3 w-3" />
              Live Standings
            </span>
          </div>

          <h1 className="mt-6 font-display text-4xl font-black tracking-tighter text-white sm:text-5xl lg:text-6xl">
            World Cup 2026 — Standings
          </h1>
          <p className="mt-4 max-w-2xl text-lg leading-relaxed text-brand-silver">
            Live group-stage tables for the 2026 World Cup, powered by real-time
            data. Standings populate as group matches are played.
          </p>
        </div>
      </section>

      {/* Header ad */}
      <section className="mx-auto max-w-7xl px-4 pt-8 sm:px-6 lg:px-8">
        <AdSlot variant="header" />
      </section>

      {/* Widget */}
      <section className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8" data-testid="standings-section">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-9">
            <StandingsWidget />

            {/* Independent disclaimer */}
            <div
              data-testid="standings-disclaimer"
              className="mt-6 flex items-start gap-3 rounded-xl border border-brand-navy bg-brand-navy/20 px-5 py-4"
            >
              <ShieldAlert className="mt-0.5 h-5 w-5 shrink-0 text-brand-silver" />
              <p className="text-xs leading-relaxed text-brand-silver">
                Standings data is provided by a third-party sports data feed
                (API-Sports) and may be delayed or contain errors — always verify
                against official sources. AI First Sports is an independent platform
                and is not affiliated with FIFA or any official tournament body.
                Nothing here is betting or gambling advice.
              </p>
            </div>
          </div>

          <aside className="lg:col-span-3">
            <div className="lg:sticky lg:top-24 space-y-6">
              <AdSlot variant="sidebar" />
              <div className="rounded-xl border border-brand-navy bg-brand-navy/30 p-5">
                <p className="font-mono-data text-[10px] uppercase tracking-[0.2em] text-brand-cyan">
                  More from football
                </p>
                <p className="mt-3 text-sm leading-relaxed text-brand-silver">
                  The Match Analyzer, Team Comparison and AI Daily Digest are on
                  the way. Join the list to get early access.
                </p>
                <Link
                  to="/sports/football"
                  data-testid="standings-football-link"
                  className="mt-4 inline-block text-sm font-medium text-brand-cyan transition-colors hover:text-white"
                >
                  Visit Football Hub →
                </Link>
              </div>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
}
